module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "edit_wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "choice_brand mt20 mb20"
  }, [_c('div', {
    staticClass: "add_name"
  }, [_c('div', {
    staticClass: "c_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌中文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetails.brandName))]), _vm._v(" "), (_vm.snapshot && _vm.snapshot.brandName) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandName))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌英文名称：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetails.brandEnname))]), _vm._v(" "), (_vm.snapshot && _vm.snapshot.brandEnname) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandEnname))]) : _vm._e()]), _vm._v(" "), (_vm.brandDetails.brandDesc) ? _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("品牌介绍：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetails.brandDesc))]), _vm._v(" "), (_vm.snapshot && _vm.snapshot.brandDesc) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandDesc))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.brandGoodsDesc) ? _c('div', {
    staticClass: "e_name"
  }, [_c('span', {
    staticClass: "form_color"
  }, [_vm._v("重点商品：")]), _vm._v(" "), _c('span', {
    staticClass: "f999"
  }, [_vm._v(_vm._s(_vm.brandDetails.brandGoodsDesc))]), _vm._v(" "), (_vm.snapshot && _vm.snapshot.brandGoodsDesc) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm.snapshot.brandGoodsDesc))]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('el-form', {
    staticClass: "demo-ruleForm",
    attrs: {
      "label-width": "207px"
    }
  }, [(_vm.hasSelBrand == 1 && (_vm.brandDetails.brandId == null || _vm.brandDetails.brandId == 0)) ? _c('el-form-item', {
    staticClass: "ml50",
    attrs: {
      "label": "选择大V已录入的品牌："
    }
  }, [
    [_c('el-select', {
      attrs: {
        "filterable": "",
        "remote": "",
        "placeholder": "请输入关键词",
        "remote-method": _vm.initBrandList,
        "loading": _vm.loading
      },
      model: {
        value: (_vm.brandId),
        callback: function($$v) {
          _vm.brandId = $$v
        },
        expression: "brandId"
      }
    }, _vm._l((_vm.options), function(item) {
      return _c('el-option', {
        key: item.brandId,
        attrs: {
          "label": item.brandName,
          "value": item.brandId
        }
      })
    }))]
  ], 2) : _vm._e(), _vm._v(" "), _c('p'), _vm._v(" "), (_vm.hasSelBrand == 1 && (_vm.brandDetails.brandId == null || _vm.brandDetails.brandId == 0)) ? _c('div', {
    staticClass: "ml97 mt10"
  }, [_c('span', {
    staticClass: "main_word"
  }, [_vm._v("如果大V服务平台还没有该品牌，请现在ECShop添加要用的品牌信息")])]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品类合作类型："
    }
  }, [_c('el-checkbox-group', {
    staticClass: "dib vtb ml_10",
    model: {
      value: (_vm.categoryType),
      callback: function($$v) {
        _vm.categoryType = $$v
      },
      expression: "categoryType"
    }
  }, [_c('el-checkbox', {
    attrs: {
      "label": "1",
      "disabled": ""
    }
  }, [_vm._v("图书类")]), _vm._v(" "), _c('el-checkbox', {
    attrs: {
      "label": "2",
      "disabled": ""
    }
  }, [_vm._v("非图书类")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌合作品类："
    }
  }), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label-width": "60px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return _vm.brandDetails.categories && _vm.brandDetails.categories.length > 0 ? [_c('el-table', {
          staticStyle: {
            "width": "92%",
            "margin": "0 auto"
          },
          attrs: {
            "data": _vm.brandDetails.categories,
            "border": ""
          }
        }, [_c('el-table-column', {
          attrs: {
            "label": "主营品类",
            "width": "200",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [_c('span', [_vm._v(_vm._s(scope.row.category.grandName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.parentName) + "--")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(scope.row.category.childrenName))])]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "是否提供发票",
            "width": "140",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("否")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1) ? _c('span', [_vm._v("是")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "发票类型",
            "align": "center",
            "width": "180"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.provideInvoice == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 1) ? _c('span', [_vm._v("增值税普通发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 1 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.taxpayerType == 2 && _vm.registeredCountry == 1 && scope.row.invoiceType == 2) ? _c('span', [_vm._v("增值税专用发票（需去税务局代开）")]) : _vm._e(), _vm._v(" "), (scope.row.provideInvoice == 1 && _vm.registeredCountry != 1 && scope.row.invoiceType == 3) ? _c('span', [_vm._v("形式发票")]) : _vm._e()]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "label": "税率",
            "align": "center",
            "min-width": "150"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.rates.length == 0) ? _c('span', [_vm._v("无")]) : _vm._e(), _vm._v(" "), _vm._l((scope.row.rates), function(rateValue) {
                return (scope.row.rates.length > 0) ? _c('span', [_vm._v("\n                                " + _vm._s(rateValue) + "%\n                                ")]) : _vm._e()
              })]
            }
          }])
        }), _vm._v(" "), _c('el-table-column', {
          attrs: {
            "width": "200",
            "label": "品类经营特许资质电子版",
            "align": "center"
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function(scope) {
              return [(scope.row.franchiseQualification == 1) ? _c('img', {
                staticClass: "pic_skan",
                attrs: {
                  "src": scope.row.franchiseQualificationFile
                },
                on: {
                  "click": function($event) {
                    _vm.previewPic($event)
                  }
                }
              }) : _vm._e(), _vm._v(" "), (!scope.row.franchiseQualification == 1) ? _c('span', [_vm._v("不需要")]) : _vm._e()]
            }
          }])
        })], 1)] : undefined
      }
    }])
  }), _vm._v(" "), (_vm.brandDetails.categoryNotBook == 1) ? _c('div', [_c('el-form-item', {
    attrs: {
      "label": "商品是否进口："
    }
  }, [(_vm.brandDetails.goodsType == 1) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("非进口")]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.goodsType == 2) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("进口")]) : _vm._e(), _vm._v(" "), (_vm.snapshot && _vm.snapshot.goodsType == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   非进口")]) : _vm._e(), _vm._v(" "), (_vm.snapshot && _vm.snapshot.goodsType == 2) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   进口")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "品牌经营方式："
    }
  }, [(_vm.brandDetails.businessType == 1) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("自有品牌")]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.businessType == 2) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("代理商")]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.businessType == 3) ? _c('span', {
    staticClass: "f999 f12"
  }, [_vm._v("其他")]) : _vm._e(), _vm._v(" "), (_vm.snapshot && _vm.snapshot.businessType == 1) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   自有品牌")]) : _vm._e(), _vm._v(" "), (_vm.snapshot && _vm.snapshot.businessType == 2) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   代理商")]) : _vm._e(), _vm._v(" "), (_vm.snapshot && _vm.snapshot.businessType == 3) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   其他")]) : _vm._e()]), _vm._v(" "), (_vm.brandDetails.businessType == 1 || _vm.brandDetails.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "商标注册证电子版："
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.trademarkRegistrationCertificateFiles), function(rcFile) {
    return (_vm.brandDetails.trademarkRegistrationCertificateFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": rcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.trademarkRegistrationCertificateFiles), function(srcFile) {
    return (_vm.snapshot && srcFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": srcFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.businessType == 1 || _vm.brandDetails.businessType == 2) ? _c('el-form-item', {
    attrs: {
      "label": "完整授权链证书电子版："
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.authCertificateFiles), function(acFile) {
    return (_vm.brandDetails.authCertificateFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": acFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.authCertificateFiles), function(sacFile) {
    return (_vm.snapshot && sacFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": sacFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.businessType == 3) ? _c('el-form-item', {
    attrs: {
      "label": "订货单电子版："
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.purchaseOrderFiles), function(poFile) {
    return (_vm.brandDetails.purchaseOrderFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": poFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.purchaseOrderFiles), function(spoFile) {
    return (_vm.snapshot && spoFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": spoFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.brandDetails.customsDeclarationFormFiles.length > 0 && _vm.brandDetails.customsDeclarationFormFiles[0] != '')),
      expression: "(brandDetails.customsDeclarationFormFiles.length > 0 && brandDetails.customsDeclarationFormFiles[0]!='')"
    }],
    attrs: {
      "label": "报关单扫描件："
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.customsDeclarationFormFiles), function(cdfFile) {
    return (_vm.brandDetails.customsDeclarationFormFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": cdfFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.customsDeclarationFormFiles), function(scdfFile) {
    return (_vm.snapshot && scdfFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": scdfFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.registeredCountry == 1 && _vm.brandDetails.goodsType == 1 && (_vm.brandDetails.businessType == 1 || _vm.brandDetails.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检单电子版："
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.qualityInspectionFiles), function(qiFile) {
    return (_vm.brandDetails.qualityInspectionFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": qiFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.qualityInspectionFiles), function(sqiFile) {
    return (_vm.snapshot && sqiFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": sqiFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.goodsType == 2) ? _c('el-form-item', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.brandDetails.inspectionQuarantineFiles.length > 0 && _vm.brandDetails.inspectionQuarantineFiles[0] != '')),
      expression: "(brandDetails.inspectionQuarantineFiles.length > 0 && brandDetails.inspectionQuarantineFiles[0]!='')"
    }],
    staticClass: "dib",
    attrs: {
      "label": "入境货物检验检疫证明：",
      "prop": "inspectionQuarantineFile"
    }
  }, [_c('div', [_vm._l((_vm.brandDetails.inspectionQuarantineFiles), function(iqFile) {
    return (_vm.brandDetails.inspectionQuarantineFiles) ? _c('img', {
      staticClass: "pic_skan",
      attrs: {
        "src": iqFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  }), _vm._v(" "), _vm._l((_vm.snapshot.inspectionQuarantineFiles), function(siqFile) {
    return (_vm.snapshot && siqFile) ? _c('img', {
      staticClass: "pic_skan_red",
      attrs: {
        "src": siqFile
      },
      on: {
        "click": function($event) {
          _vm.previewPic($event)
        }
      }
    }) : _vm._e()
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.brandDetails.registeredCountry == 1 && _vm.brandDetails.goodsType == 1 && (_vm.brandDetails.businessType == 1 || _vm.brandDetails.businessType == 2)) ? _c('el-form-item', {
    attrs: {
      "label": "质检日期：",
      "prop": "qualityInspectionTime"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("time")(_vm.brandDetails.qualityInspectionTime)) + "\n                    "), (_vm.snapshot && _vm.snapshot.qualityInspectionTime) ? _c('span', {
    staticClass: "main_word"
  }, [_vm._v("   " + _vm._s(_vm._f("time")(_vm.snapshot.qualityInspectionTime)))]) : _vm._e()]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "mt20",
    attrs: {
      "align": "center"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.reback()
      }
    }
  }, [_vm._v("返回")]), _vm._v(" "), (_vm.hasSelBrand == 1 && (_vm.brandDetails.brandId == null || _vm.brandDetails.brandId == 0)) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveBrandRelation
    }
  }, [_vm._v("保存")]) : _vm._e()], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "size": "small"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.dialogImageUrl,
      "alt": ""
    }
  })])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "add_top"
  }, [_c('div', {
    staticClass: "add_tab active_tab"
  }, [_vm._v("品牌详情")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b56bb5ac"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/info_manage/common_detail/brand_compare_detail.vue
// module id = 567
// module chunks = 0